import { useRetailerStatus } from "@faire/marketplace-lib/stores/retailer/useRetailerStatus";
import { useSubUser } from "@faire/marketplace-lib/stores/retailer/useSubUser";

export const useMultiUserGTMV2 = (): boolean => {
  const { hasPlacedFirstOrder } = useRetailerStatus();
  const { hasEverHadActiveSubUser } = useSubUser();

  if (hasEverHadActiveSubUser || !hasPlacedFirstOrder) {
    return false;
  }

  return true;
};

export const useMultiUserGTMV2NoConstraints = (): boolean => {
  const { hasEverHadActiveSubUser } = useSubUser();

  if (hasEverHadActiveSubUser) {
    return false;
  }

  return true;
};
